import { useEffect, useRef, useState } from 'react';

import { observer } from 'mobx-react-lite';
import classes from "./PlayAudio.module.css"
import { FaPlay, FaStop } from 'react-icons/fa6';
import Button from '../Button/Button';
import SoundPlayer from 'react-sdk/SoundPlayer';

export const PlayAudioBtn = (playing, handleClick) => {
  return (
    <Button
    icon={playing ? <FaStop/> : <FaPlay />}
    onClick={handleClick} className={classes.play_button} />
  )
}


const PlayAudio = ({audio = null, volume = 1, autoplay = false, children}) => {
  const [playing, setPlaying] = useState(false);
  const howl = useRef(null)
  useEffect(() => {
    howl.current = new Howl({
      src: [audio + ".mp3"],
      volume : volume
    });
    howl.current.on("end", () => setPlaying(false))
    howl.current.on("play", () => setPlaying(true))

    return () => {
      howl.current.stop()
      setPlaying(false)
    }
  }, [audio]);

  useEffect(() => {
    if(autoplay) {
      howl.current.play()
      // setPlaying(true)
    }
  }, [audio, autoplay]);

  function handleClick() {
    SoundPlayer.playSound("click")
    if(!howl.current) return
    if (playing) {
      howl.current.stop()
      setPlaying(false)
    }
    else
      howl.current.play()
  }


  return (
    <>
      {children && children(playing, handleClick)}
    </>

    //
  );
};

export default observer(PlayAudio);
